import * as styles from "./HeaderMinimal.module.scss";

import React, { useEffect, useState } from "react";
import {
	PrimaryLogo,
	PrimaryLogoReduced,
} from "../../../../components/common/Icons";
import useWindowWidth from "../../../../hooks/useWindowWidth";
import { getLogoSize } from "../MinimalHeader.helpers";
import SkipToContent from "../SkipToContent/SkipToContent";

export interface HeaderProps {
	headerHeight: number;
	scrollHeight: number;
}

export const HeaderMinimal: React.FC<HeaderProps> = ({ scrollHeight }) => {
	const windowWidth = useWindowWidth();

	let logoImageSize = 70;
	let logoImageMaxSize = 70;
	let logoImageMinSize = 55;
	if (windowWidth >= 601) {
		logoImageSize = 120;
		logoImageMaxSize = 120;
		logoImageMinSize = 80;
	}

	const [iconSize, setIconSize] = useState(logoImageSize);
	const [prevScrollHeight, setPrevScrollHeight] = useState(scrollHeight);

	useEffect(() => {
		setIconSize(
			getLogoSize(
				iconSize,
				logoImageMaxSize,
				logoImageMinSize,
				prevScrollHeight,
				scrollHeight,
			),
		);
		setPrevScrollHeight(scrollHeight);
	}, [
		scrollHeight,
		prevScrollHeight,
		iconSize,
		logoImageMaxSize,
		logoImageMinSize,
	]);

	const logoSize = iconSize > 105 ? "standard" : "small";

	useEffect(() => {
		document.body.style.overflow = "auto";

		return () => {
			document.body.style.overflow = "auto";
		};
	}, []);

	return (
		<>
			<SkipToContent />
			<header id="dt-header" className={styles.headerouter}>
				<div className={styles.headerinner}>
					<div
						className={styles.content}
						style={{
							justifyContent: "space-between",
						}}
					>
						<a
							href={
								process.env.GATSBY_IS_PREVIEW === "true"
									? `${process.env.GATSBY_PUBLISHED_BASE_URL}`
									: "/"
							}
							id={"logo-wrapper"}
							className={styles.logowrappertop}
							aria-label="Dog's Trust Home Page"
							style={{
								display: "flex",
							}}
						>
							{logoSize === "standard" ? (
								<PrimaryLogo height={`${iconSize}px`} width={`${iconSize}px`} />
							) : (
								<PrimaryLogoReduced
									height={`${iconSize}px`}
									width={`${iconSize}px`}
								/>
							)}
						</a>
					</div>
				</div>
			</header>
		</>
	);
};

export default HeaderMinimal;
